var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    className: "si-glyph si-glyph-database-plus",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43,5 C9.98119094,5 13,3.83708138 13,2.5 C13,1.16291862 9.98119094,0 6.43,0 C2.87880906,0 0,1.16291862 0,2.5 C0,3.83708138 2.87880906,5 6.43,5 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.494,9.919 C10.055,9.919 12.941,8.937 12.941,7.723 L12.941,4.377 C12.941,5.049 10.009,6.051 6.494,6.051 C2.979,6.051 0.047,5.049 0.047,4.377 L0.047,7.723 C0.047,8.937 2.934,9.919 6.494,9.919 L6.494,9.919 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 4.915,
    height: 0.957,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0160000001,9.444 L0.0160000001,12.713 C0.0160000001,13.901 2.903,14.859 6.463,14.859 C7.332,14.859 8.16,14.8 8.918,14.697 L8.918,11.958 L10.958,11.958 L10.958,10.52 C9.789,10.841 8.198,11.081 6.463,11.081 C2.947,11.08 0.0160000001,10.1 0.0160000001,9.444 L0.0160000001,9.444 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 0.958,
    height: 4.937,
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIcon);
export default __webpack_public_path__ + "static/media/db-icon.ce4b5e282eb4f2829c20408c13526ec9.svg";
export { ForwardRef as ReactComponent };